var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"go_back"},[_c('i',{staticClass:"icon_svg el-icon-arrow-left",on:{"click":function($event){return _vm.goBackOrToHome()}}}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }